module.exports = __webpack_public_path__ + "img/app-xvideo.4e909d32.webp";